import { SignatairePaEntity } from "./signataire-pa.entity";

export class UpdateStepValidationOrder {
	id!: number;
	signataires: SignatairePaEntity[] = [];
}
